import React from 'react';

import { Tabs } from 'antd';

import 'bootstrap/dist/css/bootstrap.min.css';
import InfoRapat from './InfoRapat';
import Statistik from './Statistik';

const InfoRapatMain = () => {
  const { TabPane } = Tabs;

  function callback(key) {
    localStorage.setItem('tab', key);
  }
  return (
    <div className='container-content'>
      <div className='container-detail' style={{ paddingTop: '5px' }}>
        <Tabs
          defaultActiveKey={
            !localStorage.getItem('tab') ? '1' : localStorage.getItem('tab')
          }
          onChange={callback}>
          <TabPane tab='Info Rapat' key='1'>
            <h1 className='table-title'>INFO RAPAT</h1>
            <InfoRapat />
          </TabPane>
          <TabPane tab='Statistik' key='2'>
            <h1 className='table-title'>Statistik</h1>
            <Statistik />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default InfoRapatMain;
